import axios from '../plugins/axios.js';
import InvalidPayload from '../exceptions/InvalidPayload.js';

export default {
    async index(payload = {}) {
        if (!payload.account_id) {
            throw new InvalidPayload('Account ID not provided.');
        }

        const response = await axios.get('v1/objectives', { params: payload });

        return response.data.data;
    },

    async store(payload = {}) {
        const response = await axios.post('v1/objectives', payload);

        return response.data.data;
    },

    async update(id, payload = {}) {
        if (!id) {
            throw new InvalidPayload('ID not provided.');
        }

        const response = await axios.put(`v1/objectives/${id}`, payload);

        return response.data.data;
    },
};
